import { isPlatformServer } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  PLATFORM_ID,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { Subject, takeUntil, tap } from 'rxjs';
import { InViewService } from '../../services/in-view.service';

@Directive({
  selector: '[inView]',
  standalone: true,
})
export class InViewDirective implements AfterViewInit, OnDestroy {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private element: ElementRef<HTMLElement> = inject(ElementRef);
  private platformId = inject<string>(PLATFORM_ID);
  private check = inject(ChangeDetectorRef);
  private inViewService = inject(InViewService);
  @Input() inView: string | boolean;
  @Input() inViewKeep: boolean;
  @Input() inViewBuffer: number = 20;
  destroyed$ = new Subject<void>();

  async ngAfterViewInit() {
    if (isPlatformServer(this.platformId)) return;

    this.inViewService
      .observe(this.element)
      .pipe(
        takeUntil(this.destroyed$),
        tap(visible => {
          if (visible) this.doDisplayElement();
          else if (!this.inViewKeep) this.viewContainer.clear();
        })
      )
      .subscribe();
  }

  private doDisplayElement() {
    if (!this.viewContainer.get(0)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.check.detectChanges();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
